<template>  
    <div class="flex flex-column">
        <div class="flex flex-row align-items-center mb-3">
            <span class="text-2xl font-medium text-900">Транзакции</span>
        </div>
    </div>  
    <div v-if="!loading" class="w-full flex flex-column gap-7">
        <div v-if="transactions && transactions.length>0" class="w-full">
            <div class="w-full flex">
                <Transactions :transactions="transactions" :loading="loading" :total="total" :skip="skip" :limit="limit"
                    @update:first="updateSkip"/>
            </div>
        </div>
        <div v-else class="w-full py-3">
            <span class="text-900 font-medium">Транзакции не найдены</span>
        </div>
    </div>
    <div v-if="loading" class="w-full py-3">
        <Skeleton height="2rem" class="mb-3"/> 
    </div>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import Transactions from    '@/components/personal/Transactions.vue'
import { useRoute } from 'vue-router'

export default {
    data() {
        return {
            loading: false,
            card_id: null,
            transactions: [],
            limit: 100,
            skip: 0,
            total: 0
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
    },
    methods: {
        updateSkip(val){
            this.skip = val
            this.GetCardTransactions(this.card_id)
        },
        async GetCardTransactions(id){
            this.loading = true
            this.transactions = []
            try {
                let list = await this.connect.AdminGetVcardTransactions(id, this.limit, this.skip).then(res => res)
                if (!list.result || !list.data) {
                    this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка загрузки данных', life: 10000 })
                } else {
                    this.transactions = list.data
                    this.total = list.total || 0
                }
            } catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка загрузки данных', life: 10000 })
            }
            this.loading = false
        },
        getVendorName(vendorId) {
            return this.helper.getVendorName(vendorId)
        },
        getFormatAmount(value, currency, digits = 2) {
            if(!value) return 0
            return this.helper.format_amount(value, currency, digits)
        },
    },
    components: {
        Transactions,
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        const route = useRoute()
        if(route.params.id!='' && this.helper.is_id(route.params.id)) this.user_id = route.params.id
        this.card_id = route.params.id
        try{
            await this.GetCardTransactions(this.card_id).then(res=>res)
        }catch (error) {
            this.$toast.add({ severity: 'error', summary: 'Ошибка', detail: 'Ошибка загрузки данных', life: 10000 })
        }
    },
}
</script>